<article>
  <div class="browsersPage__background"></div>
  <section class="browsersPage__section">
    <pp-brand-logo class="browsersPage__logo" [ppFallback]="EIconPath.LOGO"></pp-brand-logo>
    <div class="browsersPage__browsers-box">
      <h4>{{ 'browser_not_supported' | ppTranslate }}</h4>

      <ul class="browsersPage__browsers">
        <h6>{{ 'recommend_browsers' | ppTranslate }}</h6>
        <div>
          @for (browser of recommendedBrowsers; track browser) {
            <li>
              <img [src]="browser.imageSrc" />
              {{ browser.browserName }}
            </li>
          }
        </div>
      </ul>

      <ul class="browsersPage__browsers">
        <h6>{{ 'we_also_support' | ppTranslate }}</h6>
        <div>
          @for (browser of supportedBrowsers; track browser) {
            <li>
              <img [src]="browser.imageSrc" />
              {{ browser.browserName }}
            </li>
          }
        </div>
      </ul>

      <footer>
        <a routerLink="/"> {{ 'ignore' | ppTranslate }} </a>
      </footer>
    </div>
  </section>
</article>
